import { Route, Switch, Redirect } from 'wouter';
import { LoginPage } from '@/pages/login';
import { TenantsListPage } from '@/pages/tenants-list';
import { TenantDetailPage } from '@/pages/tenant-detail';
import { AdminsListPage } from '@/pages/admins-list';
import { PlansListPage } from '@/pages/plans-list';
import { AdminProfilePage } from '@/pages/admin-profile';
import { ReviewQueuePage } from '@/pages/review-queue';
import { InvoiceReviewPage } from '@/pages/invoice-review';
import { DeclarationsListPage } from '@/pages/declarations-list';
import { ProveedoresListPage } from '@/pages/proveedores-list';
import { MessagingPage } from '@/pages/messaging';
import { RagPage } from '@/pages/rag';
import { AdminInternalPage } from '@/pages/admin-internal';
import { AdminCobrosPage } from '@/pages/admin-cobros';
import { AdminDashboardPage } from '@/pages/admin-dashboard';
import { AppLoginPage } from '@/pages/app/login';
import { AppRegisterPage } from '@/pages/app/register';
import { AppAuthPage } from '@/pages/app/auth';
import { AppDashboardPage } from '@/pages/app/dashboard';
import { AppInvoicesPage } from '@/pages/app/invoices';
import { AppIvaListPage } from '@/pages/app/iva-list';
import { AppRentaPage } from '@/pages/app/renta';
import { AppFinancesPage } from '@/pages/app/finances';
import { AppPresupuestosPage } from '@/pages/app/presupuestos';
import { AppClientesPage } from '@/pages/app/clientes';
import { AppCobrosPage } from '@/pages/app/cobros';
import { AppNotificationsPage } from '@/pages/app/notifications';
import { AppAccountPage } from '@/pages/app/account';
import { Toaster } from '@/components/ui/sonner';

export function App() {
  return (
    <>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <Route path="/admin/tenants" component={TenantsListPage} />
        <Route path="/admin/tenants/:id" component={TenantDetailPage} />
        <Route path="/admin/review-queue" component={ReviewQueuePage} />
        <Route path="/admin/declarations" component={DeclarationsListPage} />
        <Route path="/admin/proveedores" component={ProveedoresListPage} />
        <Route path="/admin/invoices/:id" component={InvoiceReviewPage} />
        <Route path="/admin/messaging" component={MessagingPage} />
        <Route path="/admin/rag" component={RagPage} />
        <Route path="/admin/plans" component={PlansListPage} />
        <Route path="/admin/admins" component={AdminsListPage} />
        <Route path="/admin/ia" component={AdminInternalPage} />
        <Route path="/admin/dashboard" component={AdminDashboardPage} />
        <Route path="/admin/cobros" component={AdminCobrosPage} />
        <Route path="/admin/profile" component={AdminProfilePage} />
        <Route path="/app/login" component={AppLoginPage} />
        <Route path="/app/registro" component={AppRegisterPage} />
        <Route path="/app/auth" component={AppAuthPage} />
        <Route path="/app" component={AppDashboardPage} />
        <Route path="/app/facturas" component={AppInvoicesPage} />
        <Route path="/app/iva" component={AppIvaListPage} />
        <Route path="/app/renta" component={AppRentaPage} />
        <Route path="/app/finanzas" component={AppFinancesPage} />
        <Route path="/app/presupuestos" component={AppPresupuestosPage} />
        <Route path="/app/clientes" component={AppClientesPage} />
        <Route path="/app/cobros" component={AppCobrosPage} />
        <Route path="/app/notificaciones" component={AppNotificationsPage} />
        <Route path="/app/cuenta" component={AppAccountPage} />
        <Route path="/">{() => <Redirect to="/admin/dashboard" />}</Route>
        <Route>
          <div className="min-h-screen flex items-center justify-center text-muted-foreground">
            404 — página no encontrada
          </div>
        </Route>
      </Switch>
      <Toaster />
    </>
  );
}
